/** English strings — weapon readability + combat HUD (docs/09, docs/06). */
export const enWeapons = {
  'wrarity.common': 'COMMON',
  'wrarity.rare': 'RARE',
  'wrarity.epic': 'EPIC',

  // Combat HUD
  'hud.super': 'SUPER',
  'hud.superReady': 'SUPER READY',
  'hud.dash': 'DASH',
  'wstat.crateLabel': '{name} · {rarity}',

  // Weapon info panel (effective numbers)
  'wstat.type.direct': 'DIRECT',
  'wstat.type.lobbed': 'LOBBED',
  'wstat.type.homing': 'HOMING',
  'wstat.type.aoe': '{type} + AOE',
  'wstat.perShot': 'DAMAGE / SHOT',
  'wstat.areaDps': 'AREA DPS',
  'wstat.areaValue': '+{dps} · r{r}',
  'wstat.noteLive': 'Live: cards, avg. crit, {m}× mounts, rack ×{r}',
  'wstat.noteIf': 'If equipped: cards, avg. crit, {m}× mounts, rack ×{r}',
} as const;
